<template>
    <div>
        <b-modal id="applicationsetting"
                 centered
                 size="xl"
                 ref="applicationSettingModel"
                 @shown="onApplicationSettingShown"
                 no-close-on-esc
                 no-close-on-backdrop>
            <template #modal-header>
                <h5 class="modal-title" v-if="isEditUser == true && isCustomerComunityEnabled==true && isPartnerCommunity==false">Edit Roles and Permissions</h5>
                <h5 class="modal-title" v-if="isEditUser == true && (isCustomerComunityEnabled==false || isPartnerCommunity==true)">Edit Roles </h5>
                <h5 class="modal-title" v-if="isEditUser == false">Add Roles and Permissions</h5>
            </template>

            <template #default>
                <AccountContactRole v-if="accountContactRoles.length > 0"
                                    ref="accountContactRole"
                                    :accountContactRoles="accountContactRoles"></AccountContactRole>
                <br />

        <ApplicationPermission v-if="userApplicationPermissions.length > 0 && showPermissions"
                               ref="userApplicationPermission"
                               :applicationPermissions="userApplicationPermissions"
                               :isAccountPermissionAccess="isAccountPermissionAccess"></ApplicationPermission>
            </template>

        <template v-slot:modal-footer="{ ok,cancel,hide }" class="modal-footer">
            <div v-if="isEditUser == true">
                <b-button class="um-btn" @click="HideApplicationSettingModel">Cancel</b-button>
                <b-button class="um-btn margin-left-p5rem" :disabled="!userDetail.enabled" @click="saveRolesandPermissions">Save</b-button>
            </div>
            <div v-else>
                <b-button class="um-btn"
                          @click="HideApplicationSettingModel"
                          v-if="isEditUser">BACK</b-button>
                <b-button class="um-btn" @click="MoveToNextSetting($event)">NEXT</b-button>
            </div>
        </template>
    </b-modal>
        <confirmUser v-if="user != '' && accessibleApplicationAccount != ''"
                     :roleList="SelectedUserPermissions"
                     :userDetail="user"
                     :accessibleApplicationAccount="accessibleApplicationAccount"
                     :accessibleApplications="accessibleApplications"
                     :accountContactRoles="SelectedContactRoles" :AssociatedAccount="associatedAccount"></confirmUser>
        <ErrorMessage ref="errorMessageRef" :errorMessage="errorMessageString" callbackOnClose></ErrorMessage>
        <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
        <InfoPopup :popupmessage="info.message" :title="info.title" ref="InfoModel"></InfoPopup>
        <div>
            <b-modal id="SettingCancelPromptModal"
                     ref="SettingCancelPromptModal"
                     title="BootstrapVue"
                     no-close-on-esc
                     no-close-on-backdrop>
                <template #modal-header>
                    <h5 class="modal-title">Confirmation</h5>
                </template>
                <template #default>
                    <p>You have unsaved changes. Do you want to continue without saving?</p>
                </template>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button class="um-btn" @click="CancelModal">Continue without saving</b-button>
                    <b-button class="um-btn" @click="cancel()">Cancel</b-button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import { Component as Loading } from "vue-loading-overlay";
    import "vue-loading-overlay/dist/css/index.css";
    import confirmUser from "./ConfirmUser.vue";
    import ErrorMessage from "./shared/ErrorMessage";
    import service from "../services/api.services";
    import { eventbus } from "../main";
    import ApplicationPermission from "./shared/ApplicationPermission";
    import AccountContactRole from "./shared/AccountContactRole";
    import InfoPopup from "./shared/InfoPopup";
    export default {
        name: "ApplicationSetting",
        components: {
            Loading,
            confirmUser,
            ErrorMessage,
            ApplicationPermission,
            AccountContactRole,
            InfoPopup
        },
        props: {
            applicationSettingTitle: String,
            accessibleApplications: Array,
            userDetail: {},
            accessibleApplicationAccount: {},
            accountContactRoles: Array,
            userApplicationPermissions: Array,
            isEditUser: {
                type: Boolean,
                default: false
            },
            sfAccountId: String,
            isAccountPermissionAccess: Boolean,
            associatedAccount: String,
            sfAccountNumber: String,
            isCustomerComunityEnabled: Boolean,
            isPartnerCommunity: Boolean,
            showPermissions:Boolean
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                userPermissionString: "",
                user: this.userDetail,
                AccountContactRoleList: this.accountContactRoles,
                accountContactRoleString: "",
                applicationPermissionList: this.userApplicationPermissions,
                SelectedUserPermissions: [],
                SelectedContactRoles: [],
                errorMessageString: "",
                appSettingTitle: this.applicationSettingTitle,
                isSettingDirty: false,
                info: {
                    message: "",
                    title: ""
                }
            };
        },
        watch: {
            userDetail: function (newValue) {
                newValue.AccountId = this.associatedAccount;
                this.user = newValue;
            },
            applicationSettingTitle: function (newValue) {
                this.appSettingTitle = newValue;
            }
        },
        mounted() {
            var that = this;

            //window.addEventListener("beforeunload", function (event) {
            //    that.Windowhandler(event);
            //});
            eventbus.on("applicationSetting", function (data) {
                that.applicationSetting(data);
            });
            eventbus.on("onSettingDirty", function (data) {
                that.isSettingDirty = data;
                that.$store.dispatch("setIsPageDirty", data);
            });

        },

        methods: {
            onApplicationSettingShown: function () {
                this.ShowEumPopup();
                this.$nextTick(() => {
                    this.initializeRolePermissions();
                });
            },
            //Windowhandler: function (event) {
            //    if (typeof this.$refs.accountContactRole != "undefined")
            //        this.isSettingDirty = this.$refs.accountContactRole.isRoleDirty();
            //    if (this.isSettingDirty == false)
            //        this.isSettingDirty = typeof this.$refs.userApplicationPermission!='undefined'? this.$refs.userApplicationPermission.isPermissionDirty(): false;
            //    if (this.isSettingDirty) {
            //        event.returnValue = "Write something";
            //    }
            //},
            saveRolesandPermissions: function () {
                if (!this.$store.getters.isImpersonation) {
                    var that = this;
                    that.prepareUserDetail();
                    if (that.user.roles == "") {
                        that.errorMessageString =
                            "Please select atleast one role.";
                        if (that.$refs.errorMessageRef && that.$refs.errorMessageRef.$refs["ErrorMessageModel"])
                            that.$refs.errorMessageRef.$refs["ErrorMessageModel"].show();
                        else
                            that.$bvModal.show("errormessage");
                    }
                    else if ((that.user.roles != "") || (that.user.permission == "" && !that.isCustomerComunityEnabled)) {
                        that.updateUserInfo();
                    }
                }
                else {
                    this.info.title = "Information Message";
                    this.info.message = "This action is not allowed while impersonating";
                    this.$refs.InfoModel.$refs["InfoPopupModel"].show();
                }
            },
            prepareUserDetail() {
                var that = this;
                //console.log("primary-not",that.user.sfAccountID)
                that.user.sfAccountID = that.accessibleApplicationAccount.sfAccountID;
                that.user.sfContacID = that.accessibleApplicationAccount.sfContacID;
                if (that.isCustomerComunityEnabled)
                    that.user.permission = that.$refs.userApplicationPermission.GetUserApplicationPermissions();
                else
                    that.user.permission = that.GetUserApplicationPermissions();
                that.user.roles = that.$refs.accountContactRole.GetAccountContactRoles();
                that.user.AccountId = that.associatedAccount;
                that.user.AccountNumber = that.sfAccountNumber;
                //console.log("account number", that.sfAccountNumber)
            },
            GetUserApplicationPermissions: function () {
                var that = this;
                that.RoleCheck = [];
                //console.log("permission", that.userApplicationPermissions);
                that.userApplicationPermissions.forEach(function (permissionGroup) {
                    permissionGroup.roles.forEach(function (role) {
                        if (role.isAccess == true) {
                            that.RoleCheck.push(role.label);
                        }
                    });
                });
                return that.RoleCheck;
            },
            async updateUserInfo() {
                this.isLoading = true;
                var that = this;
                var userDetail = that.user;
                await service
                    .UpdateUserPermission(userDetail)
                    .then(response => {
                        if (response.data == "200") {
                            that.isLoading = false;
                            that.$refs["applicationSettingModel"].hide();
                            eventbus.emit("backToeditfromSetting", userDetail);
                        } else {
                            that.isLoading = false;
                            that.errorMessageString = response.data;
                            if (that.$refs.errorMessageRef && that.$refs.errorMessageRef.$refs["ErrorMessageModel"])
                                that.$refs.errorMessageRef.$refs["ErrorMessageModel"].show();
                            else
                                that.$bvModal.show("errormessage");
                        }
                    })
                    .catch(error => {
                        that.isLoading = false;
                        console.log("api error:" + error);
                    })
                    .finally(() => {
                        this.$store.dispatch("setIsPageDirty", false);
                    });
            },
            applicationSetting: function (data) {
                this.appSettingTitle = data.title;
                this.userinfo = data.userDetail;
                if (this.isEditUser == false) {
                    this.$bvModal.hide("confirmuser");
                    // bvn (unlike bootstrap-vue) does not reveal the lower stacked modal when the
                    // top one is hidden, so re-open the Add Roles/Permissions modal explicitly.
                    var that = this;
                    this.$nextTick(function () {
                        that.$bvModal.show("applicationsetting");
                    });
                }
            },
            CancelModal: function () {
                if (this.isEditUser == true) {
                    eventbus.emit("backToeditfromSetting");
                }
                this.$store.dispatch("setIsPageDirty", false);
                this.$refs["applicationSettingModel"].hide();
                this.$refs["SettingCancelPromptModal"].hide();
            },
            HideApplicationSettingModel: function () {
                this.isSettingDirty = this.$refs.accountContactRole.isRoleDirty();
                if (this.isSettingDirty == false && typeof (this.$refs.userApplicationPermission) != "undefined")
                    this.isSettingDirty = this.$refs.userApplicationPermission.isPermissionDirty();
                this.SelectedUserPermissions = [];
                this.SelectedContactRoles = [];
                this.errorMessageString = "";
                this.$store.dispatch("setIsPageDirty", this.isSettingDirty);
                if (this.isSettingDirty == true) {
                    this.$bvModal.show("SettingCancelPromptModal");
                } else {
                    this.$refs["applicationSettingModel"].hide();
                    eventbus.emit("backToeditfromSetting");
                }
            },
            MoveToNextSetting: function ($event) {
                if (!this.$store.getters.isImpersonation) {
                    this.SelectedUserPermissions = this.$refs.userApplicationPermission.GetUserApplicationPermissions();
                    this.SelectedContactRoles = this.$refs.accountContactRole.GetAccountContactRoles();
                    $event.target.blur();
                    this.userPermissionString = this.SelectedUserPermissions.join();
                    this.accountContactRoleString = this.SelectedContactRoles.join();

                    if (
                        this.accountContactRoleString == ""
                    ) {
                        this.errorMessageString =
                            "Please select atleast one role.";
                        if (this.$refs.errorMessageRef && this.$refs.errorMessageRef.$refs["ErrorMessageModel"])
                            this.$refs.errorMessageRef.$refs["ErrorMessageModel"].show();
                        else
                            this.$bvModal.show("errormessage");
                    } else {
                        this.$bvModal.show("confirmuser");
                    }
                }
                else {
                    this.info.title = "Information Message";
                    this.info.message = "This action is not allowed while impersonating";
                    this.$refs.InfoModel.$refs["InfoPopupModel"].show();
                }
            }
        }
    };
</script>

<style scoped>
    .eum-popup-body {
        font-family: inherit;
        color: #333;
        padding: 0.5rem;
    }

    .eum-popup-footer-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1.5rem;
    }

    .eum-popup-checkbox-group {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .eum-popup-checkbox {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    .eum-popup-checkbox-label {
        margin: 0;
        cursor: pointer;
        font-family: inherit;
        font-size: 14px;
    }

    .eum-popup-close-btn {
        color: #00a0e3;
        font-weight: bold;
        padding: 0;
    }
</style>